import { render, staticRenderFns } from "./daoru.vue?vue&type=template&id=27399bc5&"
import script from "./daoru.vue?vue&type=script&lang=js&"
export * from "./daoru.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports